import { API } from '../../../shared/constants';
import { apiClient } from '../../../shared/lib/apiClient';
import { Order } from '../../../shared/types';
import { OrderDto, toOrder } from '../../order/lib/to-order';
import { GoogleCommitResult, RedirectPaymentResult } from '../payment.types';
import { PAYMENT_ENDPOINTS } from './payment.api-constants';
import {
    PaymentLoyaltyRequestDto,
    PaymentLoyaltyResponse,
} from './payment.api-types';

const PAYMENT_API_BASE = '/api/payment';

export async function paymentLoyalty(dto: PaymentLoyaltyRequestDto) {
    const response = await apiClient.post<
        PaymentLoyaltyRequestDto,
        PaymentLoyaltyResponse
    >(PAYMENT_API_BASE + PAYMENT_ENDPOINTS.LOYALTY, dto);

    return response.data;
}

export const postGooglePayment = async (
    orderId: string | undefined,
    loyaltyId: number,
    paymentRequest: Record<string, unknown>,
): Promise<GoogleCommitResult> => {
    const url = `${API.ORDER_GOOGLE_PAYMENT}?id=${orderId}&loyaltyId=${loyaltyId}`;
    const { data } = await apiClient.post<OrderDto & Pick<GoogleCommitResult, 'three_ds_url'>>(url, paymentRequest);
    return toOrder(data);
};

export const postEmerchantPayment = async (
    orderId: string | undefined,
    loyaltyId: number,
    paymentRequest: Record<string, unknown>,
): Promise<Order> => {
    const url = `${API.ORDER_EMERCHANT_PAYMENT}?id=${orderId}&loyaltyId=${loyaltyId}`;
    const { data } = await apiClient.post<OrderDto>(url, paymentRequest);
    return toOrder(data);
};

export const postMyPosPayment = async (
    orderId: string | undefined,
    loyaltyId: number,
): Promise<Order> => {
    const url = `${API.ORDER_MYPOS_PAYMENT}?id=${orderId}&loyaltyId=${loyaltyId}`;
    const { data } = await apiClient.get<OrderDto>(url);
    return toOrder(data);
};

export const validateAppleMerchant = (
    validationURL: string,
    orderId: string | null,
): Promise<unknown> => {
    return apiClient
        .get(
            `${API.VALIDATE_APPLE_MERCHANT}?url=${encodeURIComponent(
                validationURL,
            )}&orderId=${orderId}`,
        )
        .then((response) => response.data);
};

export const postApplePayment = async (
    orderId: string | null,
    loyaltyId: number,
    paymentToken: unknown,
): Promise<Order> => {
    const { data } = await apiClient.post<OrderDto>(
        `${PAYMENT_ENDPOINTS.APPLE_PAYMENT}?id=${orderId}&loyaltyId=${loyaltyId}`,
        paymentToken,
    );
    return toOrder(data);
};

export const startMyPosSession = async (
    orderId: string,
    loyaltyId: number,
): Promise<{ sessiontoken: string }> => {
    const { data } = await apiClient.get(
        `${PAYMENT_ENDPOINTS.MYPOS_SESSION_START}?id=${orderId}&loyaltyId=${loyaltyId}`,
    );
    return data;
};

export const startTbcSession = async (
    orderId: string,
    loyaltyId: number,
): Promise<RedirectPaymentResult> => {
    const { data } = await apiClient.get(
        `${PAYMENT_ENDPOINTS.TBC_SESSION_START}?id=${orderId}&loyaltyId=${loyaltyId}`,
    );
    return data;
};

export const startMiaPaySession = async (
    orderId: string,
): Promise<RedirectPaymentResult> => {
    const { data } = await apiClient.get(
        `${PAYMENT_ENDPOINTS.MIAPAY_SESSION_START}?id=${orderId}`,
    );
    return data;
};
